import styles from "./AnswerFieldContent.module.scss";

interface AnswerFieldData {
  id: string;
  title: string;
  value: string;
}

export default function AnswerFieldContent({
  data,
  answerField,
  onChange,
  disabled = false,
}: {
  data?: AnswerFieldData;
  answerField: AnswerField;
  onChange: (value: AnswerFieldData) => void;
  disabled?: boolean;
}) {
  if (answerField.type === "paragraph") {
    return (
      <textarea
        className={styles.answerFieldInput}
        placeholder={answerField.title}
        value={data?.value}
        onChange={(event) =>
          onChange({
            id: answerField.id,
            title: answerField.title,
            value: event.target.value,
          })
        }
        disabled={disabled}
      />
    );
  }
  return (
    <input
      className={styles.answerFieldInput}
      placeholder={answerField.title}
      value={data?.value}
      onChange={(event) =>
        onChange({
          id: answerField.id,
          title: answerField.title,
          value: event.target.value,
        })
      }
      disabled={disabled}
    />
  );
}
